import { SmartMTEditorPopup, updateSaveButtons } from "./_editor_popup";
import Cropper from "cropperjs";
import { getBlobUrl, getImgBlob, setImgBlob, setCropperInitializationFunction, setCurrentMode, showToastMessage, setIndexOnApply, getCurrentMimeType } from "./_utils";


var $ = jQuery;
let croppedImageURL = null;
let cropper = null;

export const Crop = (attachment) => {
    $('#smart-mt-crop').on('click', function () {
        setCurrentMode('crop');
        let cropContent = `
            <div class="smart-mt-content smart-mt-content-crop">
                <img id="smartmt-edit-image" src="${croppedImageURL ? croppedImageURL : attachment.url}" alt="${attachment.name}" />
            </div>`;

        let cropSidebar = `
            <div id="controls" class="sidebareffects">
            <div id="crop-shape-controls">
                    <label>Choose crop shape:</label>
                    <div class="crop-shape-buttons">
                        <button class="button crop-shape-btn" id="crop-shape-rectangle"><span class="css-shapes css-shapes-square"></span></button>
                        <button class="button crop-shape-btn" id="crop-shape-circle"><span class="css-shapes css-shapes-circle"></span></button>
                        <button class="button crop-shape-btn" id="crop-shape-triangle"><span class="css-shapes css-shapes-triangle"></span></span></button>
                        <button class="button crop-shape-btn" id="crop-shape-star"><span class="dashicons dashicons-star-filled"></span></button>
                    </div>
                </div>
                <div id="cropped-size-container">
                    <div class="width-content">
                        <label for="cropped-width">Width</label>
                        <input type="number" id="cropped-width" />
                    </div>   
                    <div class="height-content">
                        <label for="cropped-height">Height</label>
                        <input type="number" id="cropped-height" />
                    </div>
                </div>
                <div id="aspect-ratio-controls">
                    <label>Aspect Ratio</label>
                    <div class="aspect-ratio-fields">
                        <input type="number" class="aspect-ratio-width" id="aspect-ratio-width" min="1" step="1" placeholder="Aspect Width">
                        <span>:</span>
                        <input type="number" class="aspect-ratio-height" id="aspect-ratio-height" min="1" step="1" placeholder="Aspect Height">
                    </div>
                </div>
            </div>
                <div class="button-access">
                    <button class="button" id="crop-apply">
                        <span class="dashicons dashicons-saved"></span> Apply
                    </button>
                </div> `;

        SmartMTEditorPopup(cropContent, cropSidebar);
        initializeCropper();
    });

    function initializeCropper(imageElement = document.getElementById('smartmt-edit-image')) {
        if (cropper) {
            cropper.destroy();
            cropper = null;
        }

        let imgBlob = getImgBlob();
        let url = getBlobUrl(imgBlob) !== false ? getBlobUrl(imgBlob) : attachment.url;
        imageElement.src = url;
        imageElement.onload = function () {
            cropper = new Cropper(imageElement, {
                aspectRatio: NaN,
                viewMode: 1,
                autoCropArea: 0.5,
                ready: function () {
                    if (cropper) {
                        const data = cropper.getData();
                        updateCroppedSizeFields(data.width, data.height);
                    }
                },
                crop: function () {
                    if (cropper) {
                        const data = cropper.getData();
                        updateCroppedSizeFields(data.width, data.height);
                    }
                }
            });

            bindControls();
        };
    }

    setCropperInitializationFunction(initializeCropper);

    function bindControls() {
        $(document).off('click', '#crop-apply').on('click', '#crop-apply', function () {
            if (cropper) {
                applyCrop();
            }
        });

        $('#cropped-width, #cropped-height').on('input', function () {
            if (cropper) {
                const width = parseInt($('#cropped-width').val(), 10);
                const height = parseInt($('#cropped-height').val(), 10);

                if (!isNaN(width) && !isNaN(height)) {
                    const ratio = cropper.options.aspectRatio;

                    if (ratio) {
                        if ($(this).attr('id') === 'cropped-width') {
                            cropper.setData({ width, height: width / ratio });
                        } else {
                            cropper.setData({ height, width: height * ratio });
                        }
                    } else {
                        cropper.setData({ width, height });
                    }
                }
            }
        });

        $('#aspect-ratio-width, #aspect-ratio-height').on('change', function () {
            if (cropper) {
                const aspectWidth = parseInt($('#aspect-ratio-width').val(), 10);
                const aspectHeight = parseInt($('#aspect-ratio-height').val(), 10);
                if (!isNaN(aspectWidth) && !isNaN(aspectHeight) && aspectWidth > 0 && aspectHeight > 0) {
                    const ratio = aspectWidth / aspectHeight;
                    cropper.setAspectRatio(ratio);
                } else {
                    cropper.setAspectRatio(NaN);
                }
            }
        });

        $('#crop-shape-rectangle').on('click', function () {
            if (cropper) {
                cropper.setAspectRatio(NaN);
                $('.cropper-view-box, .cropper-face').css('border-radius', '0');
                $('.cropper-view-box, .cropper-face').css('clip-path', '');
            }
        });

        $('#crop-shape-circle').on('click', function () {
            if (cropper) {
                cropper.setAspectRatio(1);
                $('.cropper-view-box, .cropper-face').css('border-radius', '50%');
                $('.cropper-view-box, .cropper-face').css('clip-path', '');
            }
        });

        $('#crop-shape-triangle').on('click', function () {
            if (cropper) {
                cropper.setAspectRatio(NaN);
                $('.cropper-view-box, .cropper-face').css({
                    'border-radius': '0',
                    'clip-path': '',
                });

                $('.cropper-view-box, .cropper-face').css({
                    'clip-path': 'polygon(50% 0%, 0% 100%, 100% 100%)',
                    'border-radius': '0',
                });
            }
        });

        $('#crop-shape-star').on('click', function () {
            if (cropper) {
                cropper.setAspectRatio(NaN);

                $('.cropper-view-box, .cropper-face').css({
                    'border-radius': '0',
                    'clip-path': '',
                });

                $('.cropper-view-box, .cropper-face').css({
                    'clip-path': 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)',
                    'border-radius': '0',
                });
            }
        });
    }

    function updateCroppedSizeFields(width, height) {
        $("#cropped-width").val(Math.round(width));
        $("#cropped-height").val(Math.round(height));
    }

    function applyCrop() {
        if (!cropper) {
            console.error("Error: Cropper instance not found.");
            return;
        }

        setIndexOnApply(+window.SmartMT.currentIndex);

        const croppedCanvas = cropper.getCroppedCanvas();
        if (!croppedCanvas) {
            console.error("Error: Failed to get cropped canvas.");
            showToastMessage("Cropper instance not found. Please try again.", "error");
            return;
        }

        const cropData = cropper.getData();

        // Determine if a custom shape crop is requested.
        const cropViewBox = $(".cropper-view-box");
        const isTriangleCrop =
            cropViewBox.css("clip-path") === "polygon(50% 0%, 0% 100%, 100% 100%)";
        const isCircleCrop = cropViewBox.css("border-radius") === "50%";
        const isStarCrop =
            cropViewBox.css("clip-path") ===
            "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)";

        const processBlobResult = (blob, width, height) => {
            if (!blob) {
                console.error("Error: Blob creation failed.");
                showToastMessage(
                    "Failed to create the cropped image. Please try again.",
                    "error"
                );
                return;
            }

            const url = getBlobUrl(blob);
            croppedImageURL = url;
            setImgBlob(blob);
            window.SmartMT.croppedWidth = width;
            window.SmartMT.croppedHeight = height;

            const imageElement = document.getElementById("smartmt-edit-image");
            if (imageElement) {
                imageElement.src = url;
            }

            cropper.destroy();

            imageElement.onload = function () {
                cropper = new Cropper(imageElement, {
                    aspectRatio: NaN,
                    viewMode: 1,
                    autoCropArea: 1,
                    ready: function () {
                        const data = cropper.getData();
                        updateCroppedSizeFields(data.width, data.height);
                    },
                    crop: function () {
                        const data = cropper.getData();
                        updateCroppedSizeFields(data.width, data.height);
                    },
                });
                bindControls();
            };

            showToastMessage("Successfully Applied", "success");
        };

        // If one of the custom shapes is selected, create a custom-shaped canvas.
        if (isTriangleCrop || isCircleCrop || isStarCrop) {
            const shapeCanvas = document.createElement("canvas");
            shapeCanvas.width = cropData.width;
            shapeCanvas.height = cropData.height;
            const ctx = shapeCanvas.getContext("2d");
            ctx.clearRect(0, 0, cropData.width, cropData.height);

            ctx.beginPath();
            if (isTriangleCrop) {
                ctx.moveTo(cropData.width / 2, 0);
                ctx.lineTo(0, cropData.height);
                ctx.lineTo(cropData.width, cropData.height);
            } else if (isCircleCrop) {
                ctx.arc(
                    cropData.width / 2,
                    cropData.height / 2,
                    Math.min(cropData.width, cropData.height) / 2,
                    0,
                    2 * Math.PI
                );
            } else if (isStarCrop) {
                ctx.moveTo(cropData.width * 0.5, 0);
                ctx.lineTo(cropData.width * 0.61, cropData.height * 0.35);
                ctx.lineTo(cropData.width * 0.98, cropData.height * 0.35);
                ctx.lineTo(cropData.width * 0.68, cropData.height * 0.57);
                ctx.lineTo(cropData.width * 0.79, cropData.height * 0.91);
                ctx.lineTo(cropData.width * 0.5, cropData.height * 0.7);
                ctx.lineTo(cropData.width * 0.21, cropData.height * 0.91);
                ctx.lineTo(cropData.width * 0.32, cropData.height * 0.57);
                ctx.lineTo(cropData.width * 0.02, cropData.height * 0.35);
                ctx.lineTo(cropData.width * 0.39, cropData.height * 0.35);
            }
            ctx.closePath();
            ctx.clip();

            ctx.drawImage(croppedCanvas, 0, 0, cropData.width, cropData.height);
            shapeCanvas.toBlob((blob) => {
                processBlobResult(blob, cropData.width, cropData.height);
            }, "image/png");
        } else {
            // Standard crop processing.
            croppedCanvas.toBlob((blob) => {
                processBlobResult(blob, croppedCanvas.width, croppedCanvas.height);
            }, getCurrentMimeType());
        }
    }
};
